import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { UserStateService } from '../../auth/user-state-service';
import { MatTabsModule } from '@angular/material/tabs';
import { OverlaysService } from '../../data-access-layer/global-overlays/overlays.service';
import { ActivatedRoute } from '@angular/router';
import { CacheService } from './services/cache.service';
import { CustomScoringService } from './services/custom-scoring.service';
import { MatTableDataSource } from '@angular/material/table';
import { CustomScoring, CustomScoringScope } from './model/custom-service';
import { Dataset } from 'src/app/model/dataset/dataset';
import { TessadataDatasetStructure } from 'src/app/core/tessadata/tessadata-dataset-structure';
import { SidePanelComponent } from 'src/app/core/side-panel/side-panel.component';
import { MatDialog } from '@angular/material/dialog';
import { DialogModel } from 'src/app/model/dialog/dialog-model';
import { take, takeUntil } from "rxjs/operators";
import { Subject } from 'rxjs';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { NotifService } from 'src/app/core/notification/notif.service';
import { GroupService } from 'src/app/data-access-layer/groups/group.service';
import { DatapointsAggregateService } from 'src/app/data-access-layer/datapoints/datapoints-aggregate.service';
import { AddCustomScoringComponent } from './add-custom-scoring/add-custom-scoring.component';
import { TessadataService } from 'src/app/data-access-layer/tessadata.service';
import { forkJoin } from 'rxjs';
import { TessadataDatasetType } from 'src/app/core/tessadata/tessadata-dataset-type';
import { SidePanels } from 'src/app/shared/services/side-panel.helper';
import { WorkspaceItemService } from 'src/app/data-access-layer/workspace-item/workspace-item.service';
import { WorkspaceItemType } from 'src/app/model/workspace/workspace-item-type';
import { WorkspaceItemAccess } from 'src/app/model/workspace/workspace-item-access';

export enum DatasetType {
  LOCATIONS = 'Locations',
  EXTERNAL = 'External',
  GLOBAL = 'Global'
}

@Component({
  selector: 'map-custom-scoring',
  templateUrl: './custom-scoring.component.html',
  styleUrls: ['./custom-scoring.component.scss']
})
export class CustomScoringComponent implements AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();

  breadCrumbs = ["Home", "Accounts", "Settings"];
  accountId: number;
  selectedOptions: String = 'Locations';
  cacheDurationTime = 2;
  customScoringList: CustomScoring[];
  dataSource: any;
  globalOverlays: Dataset[];
  externalOverlays: Dataset[];
  displayedColumns: string[] = ['name', 'Actions'];
  applyIcon: string = "icon1"
  isOverlays:boolean = false
  climateGroupNames = ['Climate Change', 'Climate Change Risk Score'];
  climateDatasetIDs: string[] = [];
  actionColumnNameTitle: string = 'Actions';
  dataToEdit: any;
  @ViewChild("customScoringPanel") customScoringPanel: SidePanelComponent;
  @ViewChild("globalDatasetPanel") globalDatasetPanel: SidePanelComponent;
  @ViewChild("addCustomScoring") addCustomScoring: AddCustomScoringComponent;
  @ViewChild('filterComp', { read: ElementRef }) filterCompRef: ElementRef;
  isActionGloablAndExtenalDataset: boolean = true;
  dataSetRecord: any;
  isEdit: boolean = false;
  textOptions = [];
  panelTitle: string = '';
  customScoringType: any;
  groupNodes: any;
  originalGroupNodes: any;
  constructor(
    public userStateService: UserStateService,
    private overlayService: OverlaysService,
    private cacheService: CacheService,
    private customService: CustomScoringService,
    private readonly route: ActivatedRoute,
    public readonly dialog: MatDialog,
    private readonly notifService: NotifService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly groupService: GroupService,
    private readonly datapointsAggregateService: DatapointsAggregateService,
    private readonly tessadataService: TessadataService,
    private readonly workspaceItemService: WorkspaceItemService,

  ) {
    this.userStateService = userStateService;
    this.overlayService = overlayService;
    this.cacheService = cacheService;
  }

  ngAfterViewInit() {
    // Subscribe to panel hide events to reset component state
    this.customScoringPanel.hideModal$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.resetAddCustomScoringState();
      });
  }

  private resetAddCustomScoringState() {
    if (!this.addCustomScoring) return;
    
    this.addCustomScoring.createAccountForm?.reset();
    this.addCustomScoring.uniqueGroupsCache = [];
    this.addCustomScoring.overlaysByGroupCache = {};
    this.addCustomScoring.isDropdownInitialized = false;
    this.addCustomScoring.originalFieldValue = null;
    this.addCustomScoring.fieldGroups = [];
    this.addCustomScoring.isEdit = false;
    this.addCustomScoring.existingData = null;
    this.addCustomScoring.dataToEdit = null;
    this.isEdit = false;
    this.dataToEdit = null;
  }

  ngOnInit() {
    this.accountId = +this.route.snapshot.paramMap.get("accountId");

    // Fetch climate dataset IDs first
    // CLIMATE DISABLED: Commented out to hide climate from custom scoring
    // this.overlayService.getOverlayGroupsAsTree(this.accountId)
    //     .subscribe((res) => {
    //         if (res) {
    //             const filteredTree = this.filterGroupNodes(res);
    //             // Extract dataset IDs from climate groups (now nested under parent Climate)
    //             this.climateDatasetIDs = [];
    //             const extractDatasetIDs = (nodes: any[]) => {
    //                 nodes.forEach(node => {
    //                     if (node.overlays && node.overlays.length > 0) {
    //                         node.overlays.forEach(overlay => {
    //                             const datasetID = overlay.id;
    //                             if (datasetID && !this.climateDatasetIDs.includes(datasetID)) {
    //                                 this.climateDatasetIDs.push(datasetID);
    //                             }
    //                         });
    //                     }
    //                     if (node.children && node.children.length > 0) {
    //                         extractDatasetIDs(node.children);
    //                     }
    //                 });
    //             };
    //             extractDatasetIDs(filteredTree);

    // Fetch INTERNAL (Locations) custom scorings
    this.customService.getCustomScoringsForAccount(this.accountId, CustomScoringScope.INTERNAL)
        .subscribe((internalData) => {
            this.customScoringList = internalData || [];

            // Fetch FORMULA scope custom scorings
            this.customService.getCustomScoringsForAccount(this.accountId, CustomScoringScope.FORMULA)
                .subscribe((formulaData) => {
                    if (formulaData && formulaData.length > 0) {
                        this.customScoringList = [...this.customScoringList, ...formulaData];
                    }

                    // Fetch all GLOBAL custom scorings (without datasetID filter)
                    // CLIMATE DISABLED: Commented out to hide climate custom scorings from list
                    // this.customService.getCustomScoringsForAccount(this.accountId, CustomScoringScope.GLOBAL)
                    //     .subscribe((globalData) => {
                    //         if (globalData && globalData.length > 0) {
                    //             // Filter to only include climate-related custom scorings
                    //             const climateGlobalScorings = globalData.filter(scoring => {
                    //                 return this.climateDatasetIDs.includes(scoring.datasetID);
                    //             });
                    //             this.customScoringList = [...this.customScoringList, ...climateGlobalScorings];
                    //         }
                    //         this.finalizeLocationsList();
                    //     });
                    this.finalizeLocationsList();
                });
        });
  }

  public onDatasetChange(isPanel = false) {
    if (isPanel) {
      this.customScoringPanel.hidePanel();
      this.customScoringPanel.closePanel();
      this.globalDatasetPanel.hidePanel();
      this.globalDatasetPanel.closePanel();

      this.addCustomScoring.clearFormValidators(this.addCustomScoring.createAccountForm);
      this.addCustomScoring.createAccountForm.reset();
  
      this.addCustomScoring.isDropdownValueSelected = false;
      this.isEdit = false;
      this.dataToEdit = null;
      this.changeDetector.detectChanges();
    }
    if (this.selectedOptions === 'Locations') {
      this.displayedColumns = ['name', 'Actions'];
    } else {
      this.displayedColumns = ['name', 'datasetId', 'Actions'];
      this.actionColumnNameTitle = 'Custom Scoring';
    }
    switch (this.selectedOptions) {
      case DatasetType.LOCATIONS:
        this.dataSource = null
        this.isOverlays = false
        // First fetch climate dataset IDs
        // CLIMATE DISABLED: Commented out to hide climate from custom scoring
        // this.overlayService.getOverlayGroupsAsTree(this.accountId)
        //     .subscribe((res) => {
        //         if (res) {
        //             const filteredTree = this.filterGroupNodes(res);
        //             // Extract dataset IDs from climate groups (now nested under parent Climate)
        //             this.climateDatasetIDs = [];
        //             const extractDatasetIDs = (nodes: any[]) => {
        //                 nodes.forEach(node => {
        //                     if (node.overlays && node.overlays.length > 0) {
        //                         node.overlays.forEach(overlay => {
        //                             const datasetID = overlay.id;
        //                             if (datasetID && !this.climateDatasetIDs.includes(datasetID)) {
        //                                 this.climateDatasetIDs.push(datasetID);
        //                             }
        //                         });
        //                     }
        //                     if (node.children && node.children.length > 0) {
        //                         extractDatasetIDs(node.children);
        //                     }
        //                 });
        //             };
        //             extractDatasetIDs(filteredTree);

        // Fetch INTERNAL (Locations) custom scorings
        this.customService.getCustomScoringsForAccount(this.accountId, CustomScoringScope.INTERNAL)
            .subscribe((internalData) => {
                this.customScoringList = internalData || [];

                // Fetch FORMULA scope custom scorings
                this.customService.getCustomScoringsForAccount(this.accountId, CustomScoringScope.FORMULA)
                    .subscribe((formulaData) => {
                        if (formulaData && formulaData.length > 0) {
                            this.customScoringList = [...this.customScoringList, ...formulaData];
                        }

                        // Fetch all GLOBAL custom scorings (without datasetID filter)
                        // CLIMATE DISABLED: Commented out to hide climate custom scorings from list
                        // this.customService.getCustomScoringsForAccount(this.accountId, CustomScoringScope.GLOBAL)
                        //     .subscribe((globalData) => {
                        //         if (globalData && globalData.length > 0) {
                        //             // Filter to only include climate-related custom scorings
                        //             const climateGlobalScorings = globalData.filter(scoring => {
                        //                 return this.climateDatasetIDs.includes(scoring.datasetID);
                        //             });
                        //             this.customScoringList = [...this.customScoringList, ...climateGlobalScorings];
                        //         }
                        //         this.finalizeLocationsList();
                        //     });
                        this.finalizeLocationsList();
                    });
            });
        break;
      // case DatasetType.EXTERNAL:
      //   this.dataSource = null
      //   this.isOverlays = true
      //   this.groupNodes = null;
      //   forkJoin({
      //     tessadata: this.tessadataService.fetchDatasets(TessadataDatasetType.LOCATION_DATA, this.accountId)
      //   }).subscribe(({ tessadata }) => {
      //     const tessadataGroups = tessadata.map(country => {
      //       return {
      //         group: {
      //           name: country.countryName.trim(),
      //         },
      //         overlays: country.datasets.map(dataset => ({
      //           datasetId: dataset.datasetId,
      //           datasetLabel: dataset.datasetLabel,
      //           externalDatasetKey: dataset.datasetId,
      //           showInMap: SidePanels.FILTER_PANEL,
      //           id: dataset.datasetId,
      //           name: dataset.datasetLabel,
      //           fields: []
      //         })),
      //         children: [],
      //         isOpen: false
      //       };
      //     });
      //     const combinedTree = [
      //       ...tessadataGroups
      //     ];
      //     this.groupNodes = combinedTree;
      //     this.originalGroupNodes = combinedTree;
      //   });
      //   break;
      case DatasetType.GLOBAL:
        this.dataSource = null
        this.groupNodes = null;
        this.isOverlays = true
                this.overlayService.getOverlayGroupsAsTree(this.accountId)
                .subscribe((res) => {
                    if (res) {
                        const filteredTree = this.filterGroupNodes(res);
                        this.groupNodes = filteredTree
                        this.originalGroupNodes = filteredTree
                        this.changeDetector.detectChanges();
                    }
                });
        break;
      default:

    }

    const inputElement: HTMLInputElement = this.filterCompRef.nativeElement.querySelector('input');    
    if (inputElement) {
      inputElement.value = '';
    }
  }

  applyFilter(filterValue: string): void {
    const trimmedFilter = filterValue.trim().toLowerCase();
    if (this.selectedOptions === 'Locations') {
    this.dataSource.filterPredicate = (data: any, filter: string): boolean => {
      if (!filter) {
        return true;
      }      
      return data.name?.toLowerCase().includes(filter);
    };
    this.dataSource.filter = trimmedFilter;
    }
    else {
      this.groupNodes = this.filterTree(this.originalGroupNodes, trimmedFilter);
    }
  }
  editCustomScoring(customScoring): void {
    this.customService.getCustomScoring(this.accountId,customScoring._id).subscribe((data) => {
        this.isEdit = true;
        this.dataToEdit = data;

        // Always load both Locations and Formulas for edit mode
        let locationDataset = JSON.parse(localStorage.getItem("locationDataSetItem_"+this.accountId));
        let locationCustomFields = JSON.parse(localStorage.getItem("locationCustomFields_"+this.accountId)) || [];

        // Check if this is a formula custom scoring (FORMULA scope)
        if (data.scope === 'FORMULA') {
            // Formula-based editing logic
            this.customScoringType = CustomScoringScope.FORMULA;
            this.panelTitle = 'Locations';

            this.workspaceItemService.getAllWorkspaceItemsForUser(data.datasetID, WorkspaceItemType.FORMULA)
                .subscribe((formulas) => {
                    const accountLevelFormulas = (formulas || []).filter(formula => formula.access === WorkspaceItemAccess.GLOBAL);
                    const formulaGroup = {
                        groupName: 'Formulas',
                        fields: accountLevelFormulas.map(formula => ({
                            id: formula.id,
                            name: formula.name,
                            displayName: formula.name,
                            type: 'FORMULA',
                            datasetId: formula.datasetId,
                            formulaData: formula.data
                        }))
                    };

                    const locationGroup = {
                        groupName: 'Locations',
                        fields: locationCustomFields
                    };

                    // Pass data to add-custom-scoring component - include both groups
                    this.addCustomScoring.customScoringScope = CustomScoringScope.FORMULA;
                    this.addCustomScoring.selectedGroupDatasetID = data.datasetID;
                    this.addCustomScoring.fieldGroups = [locationGroup, formulaGroup];
                    this.addCustomScoring.locationDatasetRecord = locationDataset;
                    this.addCustomScoring.isEdit = true;
                    this.addCustomScoring.dataToEdit = data;
                    this.addCustomScoring.existingData = data;

                    this.customScoringPanel.showPanel();
                    this.addCustomScoring.initEditMode();
                    this.changeDetector.detectChanges();
                });
        } else if (data.scope === 'GLOBAL') {
            // Fetch climate overlay fields for editing
            this.overlayService.getOverlayGroupsAsTree(this.accountId)
                .subscribe((res) => {
                    if (res) {
                        const filteredTree = this.filterGroupNodes(res);
                        // Find the overlay that matches the field
                        let selectedOverlay = null;
                        let selectedGroup = null;
                        let datasetID = data.datasetID;

                        // Search in parent Climate group's children
                        filteredTree.forEach(group => {
                            if (group.group?.name === 'Climate' && group.children) {
                                group.children.forEach(child => {
                                    const overlay = child.overlays?.find(ovl => ovl.id === datasetID);
                                    if (overlay) {
                                        selectedOverlay = overlay;
                                        selectedGroup = child;
                                    }
                                });
                            } else {
                                // Also check direct overlays (for backward compatibility)
                                const overlay = group.overlays?.find(ovl => ovl.id === datasetID);
                                if (overlay) {
                                    selectedOverlay = overlay;
                                    selectedGroup = group;
                                }
                            }
                        });

                        if (selectedOverlay) {
                            this.dataSetRecord = {
                                id: selectedOverlay.id,
                                name: selectedOverlay.name,
                                fields: selectedOverlay.fields || []
                            };
                            this.customScoringType = CustomScoringScope.GLOBAL;
                            this.panelTitle = 'Global Datasets';

                            // Create fieldGroups with climate overlay data for editing
                            const filteredFields = (selectedOverlay.fields || []).filter(field => field.displayInDropdowns === true);
                            const climateGroup = {
                                groupName: 'Climate',
                                subGroupName: selectedGroup?.group?.name,
                                overlayName: selectedOverlay.name,
                                overlayId: selectedOverlay.id,
                                datasetID: selectedOverlay.id,
                                fields: filteredFields.map(field => ({
                                    ...field,
                                    compositeId: `${selectedOverlay.id}_${field.id}`,
                                    originalId: field.id
                                }))
                            };

                            // Pass data to add-custom-scoring component
                            this.addCustomScoring.globalDataSetRecord = this.dataSetRecord;
                            this.addCustomScoring.customScoringScope = CustomScoringScope.GLOBAL;
                            this.addCustomScoring.externalOverlaysFromGlobal = selectedOverlay.fields;
                            this.addCustomScoring.fieldGroups = [climateGroup];
                            this.addCustomScoring.locationDatasetRecord = null;
                            this.addCustomScoring.isEdit = true;
                            this.addCustomScoring.dataToEdit = data;
                            this.addCustomScoring.existingData = data;

                            this.customScoringPanel.showPanel();
                            this.addCustomScoring.initEditMode();
                            this.changeDetector.detectChanges();
                        }
                    }
                });
        } else {
            this.workspaceItemService.getAllWorkspaceItemsForUser(locationDataset.id, WorkspaceItemType.FORMULA)
                .subscribe((formulas) => {
                    const accountLevelFormulas = (formulas || []).filter(formula => formula.access === WorkspaceItemAccess.GLOBAL);
                    const formulaGroup = {
                        groupName: 'Formulas',
                        fields: accountLevelFormulas.map(formula => ({
                            id: formula.id,
                            name: formula.name,
                            displayName: formula.name,
                            type: 'FORMULA',
                            datasetId: formula.datasetId,
                            formulaData: formula.data
                        }))
                    };

                    // Create fieldGroups with both location fields and formulas
                    const locationGroup = {
                        groupName: 'Locations',
                        fields: locationCustomFields
                    };
                    
                    // Set up the edit data for INTERNAL scope
                    this.customScoringType = CustomScoringScope.INTERNAL;
                    this.panelTitle = 'Locations';
                    
                    // Pass data to add-custom-scoring component - include both groups
                    this.addCustomScoring.customScoringScope = CustomScoringScope.INTERNAL;
                    this.addCustomScoring.fieldGroups = [locationGroup, formulaGroup];
                    this.addCustomScoring.locationDatasetRecord = locationDataset;
                    this.addCustomScoring.isEdit = true;
                    this.addCustomScoring.dataToEdit = data;
                    this.addCustomScoring.existingData = data;

                    this.customScoringPanel.showPanel();
                    this.addCustomScoring.initEditMode();
                    this.changeDetector.detectChanges();
                });
        }
    });
}


  toggleIcon(customScoring) {
    this.applyIcon = this.applyIcon === "icon1" ? "icon2" : "icon1";
    let applied = customScoring.applied;
    let isSuccess = false;
    this.customService.applyFlag(this.accountId, customScoring._id, !applied).subscribe((data) => {
      this.onDatasetChange();
      this.notifService.success(
          "The custom scoring applied flag has been updated.."
      );
      isSuccess = true;
    });
    if (isSuccess) {
      this.changeDetector.detectChanges();
      return true;
    }

  }

  get componentName() {
    return this.constructor.name;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    localStorage.removeItem("global")
    localStorage.removeItem("external")
    this.customScoringPanel.hidePanel();
    this.customScoringPanel.closePanel();
    this.addCustomScoring.createAccountForm.reset();
    this.addCustomScoring.initForm();
  }

  updatetheFlag(dataSetRecord) {
    if (this.selectedOptions === 'Global') {
        this.panelTitle = 'Global Datasets';
    } else if (this.selectedOptions === 'Locations') {
        this.panelTitle = 'Locations';
    }
    // else if (this.selectedOptions === 'External') {
    //     this.panelTitle = 'External Datasets';
    //     dataSetRecord.id = dataSetRecord.datasetId;
    //     dataSetRecord.name = dataSetRecord.datasetLabel;
    // }
    this.dataSetRecord = dataSetRecord;
    this.globalDatasetPanel.showPanel();

  }

  finalizeLocationsList() {
    this.customScoringList = this.customScoringList
      .map(item => ({
        ...item,
        name: item.name.trimStart()
      }))
      .sort((a, b) => a.name.localeCompare(b.name));

    this.dataSource = new MatTableDataSource<CustomScoring>(this.customScoringList);
    this.dataSource.filter = '';
  }
  addNewScoring() {
    this.isEdit = false;
    this.dataToEdit = null;
    this.addCustomScoring.isEdit = false;
    this.addCustomScoring.existingData = null;
    this.addCustomScoring.dataToEdit = null;
    this.textOptions = null;
    this.addCustomScoring.isApplied = false;
    this.addCustomScoring.clearFormValidators(this.addCustomScoring.createAccountForm);
    this.addCustomScoring.createAccountForm.reset();
    this.addCustomScoring.isDropdownValueSelected = false;
    this.addCustomScoring.initForm();
    
    // Clear caches for fresh dropdown
    this.addCustomScoring.uniqueGroupsCache = [];
    this.addCustomScoring.overlaysByGroupCache = {};
    this.addCustomScoring.isDropdownInitialized = false;
    this.addCustomScoring.collapsedGroups = {};
    this.addCustomScoring.collapsedSubGroups = {};
    
    if (this.selectedOptions === 'Global') {
        this.customScoringType = CustomScoringScope.GLOBAL;
    } else if (this.selectedOptions === 'Locations') {
        this.customScoringType = CustomScoringScope.INTERNAL;
        
        // Load both Locations and Formulas for new custom scoring
        let locationDataset = JSON.parse(localStorage.getItem("locationDataSetItem_"+this.accountId));
        let locationCustomFields = JSON.parse(localStorage.getItem("locationCustomFields_"+this.accountId)) || [];
        
        this.workspaceItemService.getAllWorkspaceItemsForUser(locationDataset.id, WorkspaceItemType.FORMULA)
            .subscribe((formulas) => {
                const accountLevelFormulas = (formulas || []).filter(formula => formula.access === WorkspaceItemAccess.GLOBAL);
                const formulaGroup = {
                    groupName: 'Formulas',
                    fields: accountLevelFormulas.map(formula => ({
                        id: formula.id,
                        name: formula.name,
                        displayName: formula.name,
                        type: 'FORMULA',
                        datasetId: formula.datasetId,
                        formulaData: formula.data
                    }))
                };

                const locationGroup = {
                    groupName: 'Locations',
                    fields: locationCustomFields
                };
                
                this.addCustomScoring.customScoringScope = CustomScoringScope.INTERNAL;
                this.addCustomScoring.fieldGroups = [locationGroup, formulaGroup];
                this.addCustomScoring.locationDatasetRecord = locationDataset;
                
                // Collapse both groups by default for new scoring
                this.addCustomScoring.collapsedGroups['Locations'] = true;
                this.addCustomScoring.collapsedGroups['Formulas'] = true;
                this.addCustomScoring.isDropdownInitialized = true;
                
                this.changeDetector.detectChanges();
            });
    }

    // Reset fieldGroups and re-fetch data (Locations + Formulas)
    // This is needed because editCustomScoring overwrites fieldGroups with only the edit scope's fields
    this.addCustomScoring.fieldGroups = [];
    this.addCustomScoring.uniqueGroupsCache = [];
    this.addCustomScoring.overlaysByGroupCache = {};
    this.addCustomScoring.customScoringScope = this.customScoringType;
    this.addCustomScoring.externalOverlaysFromGlobal = null;
    this.addCustomScoring.globalDataSetRecord = null;
    this.addCustomScoring.getData();

    this.customScoringPanel.showPanel();
    this.changeDetector.detectChanges();
  }

  onCancelClose2() {
    this.customScoringPanel.hidePanel();
    this.customScoringPanel.closePanel();
    this.globalDatasetPanel.hidePanel();
    this.globalDatasetPanel.closePanel();
    // Note: resetAddCustomScoringState is called via hideModal$ subscription
    this.changeDetector.detectChanges();
  }

  onCreateSuccess() {
    this.changeDetector.detectChanges();
    this.onDatasetChange();

  }

  deleteCustomScoring(customScoring): void {
    const dialogRef = this.dialog.open(DialogComponent, {
        data: new DialogModel(
            "Confirm Action",
            `Are you sure you want to delete the custom scoring?`
        ),
    });
    dialogRef
        .afterClosed()
        .pipe(take(1))
        .subscribe((dialogResult) => {
            if (dialogResult) {
              this.customService
                    .deleteCustomScoring(this.accountId, customScoring._id)
                    .subscribe((success) => {
                        this.onDatasetChange();
                        this.notifService.success(
                            "The custom scoring has been deleted."
                        );
                    });
            }
        });
  }

  
  private filterGroupNodes(nodes: any[]): any[] {
    if (!Array.isArray(nodes)) {
      return [];
    }
    const climateGroupNames = ['Climate Change', 'Climate Change Risk Score'];
    const climateChildren: any[] = [];

    // Create a map of all nodes by their group ID for parent-child lookup
    const nodeMap = new Map();
    nodes.forEach(node => {
      if (node.group?.id) {
        nodeMap.set(node.group.id, node);
      }
    });

    for (const node of nodes) {
      const groupName = node.group?.name?.trim() || '';

      // Check if this is a climate group or a child of a climate group
      const isClimateGroup = climateGroupNames.includes(groupName);
      const isChildOfClimate = node.group?.parentID && nodeMap.has(node.group.parentID) &&
                               climateGroupNames.includes(nodeMap.get(node.group.parentID).group?.name?.trim() || '');

      if (!isClimateGroup && !isChildOfClimate) {
        continue;
      }

      let filteredOverlays = [];
      if (Array.isArray(node.overlays)) {
        filteredOverlays = node.overlays.filter(ovl =>
          !(
            ovl.isGeoserver === false ||
            ovl.thematicMapSettings?.isThematicMapDataset === true ||
            ovl.geometryType === 'POINT'
          )
        );
      }
      let filteredChildren = [];
      if (Array.isArray(node.children) && node.children.length > 0) {
        filteredChildren = this.filterGroupNodes(node.children);
      }
      const hasOverlays = (filteredOverlays.length > 0);
      const hasChildren = (filteredChildren.length > 0);
      if (hasOverlays || hasChildren) {
        climateChildren.push({
          ...node,
          overlays: filteredOverlays,
          children: filteredChildren
        });
      }
    }

    // Create parent Climate group if there are climate children
    if (climateChildren.length > 0) {
      return [{
        group: { name: 'Climate' },
        overlays: [],
        children: climateChildren,
        isOpen: true
      }];
    }

    return [];
  }

  private filterTree(nodes: any[], filter: string): any[] {
    const filtered: any[] = [];
  
    for (const node of nodes) {
      let nodeName = '';
      if (node.group?.name) {
        nodeName = node.group.name.toLowerCase();
      } else if (node.datasetLabel) {
        nodeName = node.datasetLabel.toLowerCase();
      }
  
      let overlayMatches = false;
      let newOverlays = [];
      if (Array.isArray(node.overlays)) {
        newOverlays = node.overlays.filter((ovl: any) => {
          let ovlName = '';
          if (ovl.name) {
            ovlName = ovl.name.toLowerCase();
          } else if (ovl.datasetLabel) {
            ovlName = ovl.datasetLabel.toLowerCase();
          }
  
          const match = ovlName.includes(filter);
          if (match) {
            overlayMatches = true;
          }
          return match;
        });
      }
  
      const nodeMatches = nodeName.includes(filter);
  
      if (nodeMatches || overlayMatches) {
        filtered.push({
          ...node,
          children: node.children,
          overlays: node.overlays
        });
      } else {
        let newChildren = [];
        if (Array.isArray(node.children) && node.children.length > 0) {
          newChildren = this.filterTree(node.children, filter);
        }  
        if (newChildren.length > 0 || newOverlays.length > 0) {
          filtered.push({
            ...node,
            children: newChildren,
            overlays: newOverlays
          });
        }
      }
    }
    return filtered;
  }

}
